import { Dispatch } from "redux";

import backend from "../../../apis/backend";
import { User } from "../types";
import { ReduxState } from "../../state";
import { updateUser } from "../actions";

export const asyncUpdateUser = (updatedUser: User) => {
  return async (dispatch: Dispatch, getState: () => ReduxState) => {
    try {
      const { loginToken } = getState().auth;
      const headers = { 'X-Auth-Token': loginToken}
      const response = await backend.put(
        `/user-service/api/v1/users/${updatedUser._id}`, updatedUser, { headers });
      if (response.status === 200) {
        dispatch(updateUser(response.data));
      } else {
        console.log('User updated')
      }
    } catch (error) {
      console.error('Error updating user', error);
    }
  };
};